import React from "react";
import { motion } from "framer-motion";
import motionTokens from "../../motion/studio/motionTokens";

function ResultCard({
  children,
  colors = {},
  style = {},
  index = 0,
}) {
  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 18,
        scale: 0.985,
      }}
      animate={{
        opacity: 1,
        y: 0,
        scale: 1,
      }}
      whileHover={{
        y: motionTokens.hoverLift,
      }}
      transition={{
        ...motionTokens.spring,
        delay: index * motionTokens.staggerFast,
      }}
      style={{
        border: `1px solid ${colors.border || "rgba(148,163,184,0.12)"}`,
        borderRadius: "20px",
        padding: "18px",
        background:
          colors.cardBgStrong || "rgba(15,23,42,0.72)",
        boxShadow:
          colors.shadowSoft ||
          "0 10px 30px rgba(15,23,42,0.12)",
        backdropFilter: "blur(18px)",
        overflow: "hidden",
        position: "relative",
        ...style,
      }}
    >
      <motion.div
        animate={{
          opacity: [0.25, 0.4, 0.25],
        }}
        transition={{
          repeat: Infinity,
          duration: 3,
        }}
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.03), transparent 42%)",
          pointerEvents: "none",
        }}
      />

      {children}
    </motion.div>
  );
}

export default ResultCard;
